/**
 * CRM Forms Async Thunks
 * All async actions for CRM forms operations
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as crmFormsApi from '../api/crmFormsApi';

/**
 * Fetch pending forms
 * API returns { data: { leads: [], patients: [] } }
 */
export const fetchPendingFormsThunk = createAsyncThunk(
  'crmForms/fetchPendingForms',
  async (_, { rejectWithValue }) => {
    try {
      const data = await crmFormsApi.fetchPendingForms();
      const result = data.data || data || {};
      return {
        leads: result.leads || [],
        patients: result.patients || [],
      };
    } catch (error) {
      console.error('Error fetching pending forms:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Fetch all forms
 * API returns an array of form documents
 */
export const fetchAllFormsThunk = createAsyncThunk(
  'crmForms/fetchAllForms',
  async (_, { rejectWithValue }) => {
    try {
      const data = await crmFormsApi.fetchAllForms();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error fetching all forms:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * Approve form
 */
export const approveFormThunk = createAsyncThunk(
  'crmForms/approveForm',
  async ({ id, type }, { rejectWithValue }) => {
    try {
      const data = await crmFormsApi.approveForm(id, type);
      return data;
    } catch (error) {
      console.error('Error approving form:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
